// @flow

import { type GrecaptchaV3 } from './types';
import { loadScript } from '@tectonics/commons/load-script';
import {getEnvVarOrCry} from '../../commons/env-parameter';
import { RecaptchaLoadError } from '../../commons/errors/recaptcha-load-error';

let loadingPromise: ?Promise<GrecaptchaV3> = null;

export function loadRecaptchaV3(): Promise<GrecaptchaV3> {
  if (loadingPromise) {
    return loadingPromise;
  }

  loadingPromise = (async () => {
    if (window.grecaptcha) {
      return (window.grecaptcha: GrecaptchaV3);
    }

    const siteKey = getEnvVarOrCry('SITE_KEY_RECAPTCHA_V3_ENTERPRISE');
    try {
      await loadScript(`https://www.google.com/recaptcha/enterprise.js?render=${siteKey}`);
    } catch (error) {
      const message = error instanceof Error ? error.message : String(error);
      throw new RecaptchaLoadError(message);
    }

    if (!window.grecaptcha) {
      throw new RecaptchaLoadError('grecaptcha not available after script load');
    }

    return (window.grecaptcha: GrecaptchaV3);
  })();

  loadingPromise.catch(() => {
    loadingPromise = null;
  });

  return loadingPromise;
}
